import { GridApi } from "ag-grid-community";
import { useEffect, useState } from "react";

function useFilterModelHighlightHTML(api: GridApi, value?: string | null) {
  const getKeyword = () => {
    const { externalSearch, externalKeyword } = api.getFilterModel();
    if (externalKeyword) {
      return externalKeyword.filter ?? "";
    }
    if (externalSearch) {
      const [_includeInactive, ...criteria] = externalSearch.filter.split("%|%");
      const keyword = criteria?.length ? criteria?.join("") : "";
      return keyword;
    }
    return "";
  };
  //@ts-ignore
  const [keyword, setKeyword] = useState(getKeyword ?? "");
  useEffect(() => {
    const callback = () => {
      //@ts-ignore
      setKeyword(getKeyword ?? "");
    };
    api.addEventListener("filterChanged", callback);
    return () => {
      api.removeEventListener("filterChanged", callback);
    };
  });
  try {
    const regex = new RegExp(keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "ig");

    return value && keyword
      ? value.replace(regex, `<span style="background-color:#FFE399">$&</span>`)
      : (value ?? "");
  } catch (_e) {
    return value ?? "";
  }
}

export default useFilterModelHighlightHTML;
